const env = {
  API_URL: process.env.REACT_APP_API_BASE_URL,
  G_MAP_API_KEY: process.env.REACT_APP_G_MAP_API_KEY,
  STRIPE: {
    CLIENT_ID: '',
  },
}

export default env
